/* eslint-disable no-empty */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import $axios from './index';


// Get Dashboard Info (GET)
export const fetchDashboardData = createAsyncThunk('get dashboard data', async () => {
  try {
    const res = await $axios.get('/admin/dashboard-info');
    return { data: res.data.data, error: null };
  } catch (err) {
    const error = err.response
      ? { status: err.response.status, message: err.response?.data?.message || 'Request failed' }
      : { status: 500, message: 'Network error' };
    return { data: null, error };
  }
});

// Slice
const dasboardSlice = createSlice({
  name: 'dasboardSlice',
  initialState: {
    dashboardData: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    // Fetch Data
    builder
      .addCase(fetchDashboardData.pending, (state, action) => {
        state.dashboardData = null;
      })
      .addCase(fetchDashboardData.fulfilled, (state, action) => {
        state.dashboardData = action.payload;
      })
  },
});

export default dasboardSlice.reducer;
